import React from 'react';
import Router from 'next/router';
import NProgress from 'nprogress';
import { translate } from 'react-i18next';
import Head from 'next/head';

import stylesheet from '../../styles/main.scss';
import Header from './header';

Router.onRouteChangeStart = () => NProgress.start();
Router.onRouteChangeComplete = () => NProgress.done();
Router.onRouteChangeError = () => NProgress.done();


class Page extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: 'is-loading'
    };
  }

  render() {
    const { t, i18n: { language }, children, ready } = this.props;
    return (
      <div className={`body print ${ready ? '' : this.state.loading}`}>
        <Head>
          <title>E. SASSONE</title>
          <meta name="description" content="E. SASSONE"/>
          <link href="/static/css/skel.css" rel="stylesheet"/>
          <link href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
                rel="stylesheet"/>
          <link href="https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,300i,600,600i" rel="stylesheet"/>
          <link rel="icon" type="image/x-icon" href="/favicon.ico"/>
        </Head>
        <style dangerouslySetInnerHTML={{ __html: stylesheet }}/>

        <div id="wrapper">
          <Header />
          {ready ? children() : (
            <>
              {t('loading')}
            </>
          )}
        </div>
      </div>
    );
  }
}

export default translate()(Page);
